import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
// import Autocomplete from "react-google-autocomplete";
// import { Label } from "@mui/icons-material";

import { usePlacesWidget } from "react-google-autocomplete";
import { ListItem, ListItemText, TextField, Icon } from "@mui/material";
import AppConfig from "appConfig";
import MDButton from "theme/components/MDButton";
import MDTypography from "theme/components/MDTypography";

function GoogleAddressField({ formRef, draftIndex, displayName, fieldRef, options }) {
  // const [googleAddressFormatted, setGoogleAddressFormatted] = useState(null);
  // const [googleAddressLatitude, setGoogleAddressLatitude] = useState(null);
  // const [googleAddressLongitude, setGoogleAddressLongitude] = useState(null);
  const [googleAddressObject, setGoogleAddressObject] = useState(null);

  const { ref } = usePlacesWidget({
    apiKey: AppConfig.google_map_key,
    onPlaceSelected: (place) => {
      // console.log(place);
      // setGoogleAddressFormatted(place.formatted_address);
      // setGoogleAddressLatitude(place.geometry.location.lat());
      // setGoogleAddressLongitude(place.geometry.location.lng());
      setGoogleAddressObject(
        JSON.stringify({
          formatted_address: place.formatted_address,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        }),
      );
    },
    options: {
      // types: ["(regions)"],
      types: ["address"],
      componentRestrictions: { country: "ng" },
    },
  });

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setDraftValue(val);
        setHasSavedValue(true);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <MDBox>
      {hasSavedValue ? (
        <MDBox>
          <ListItem divider>
            <MDBox mr={1}>
              <Icon color="success">check_circle</Icon>
            </MDBox>
            <ListItemText
              primary={
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  {displayName}
                </MDTypography>
              }
              secondary={
                <MDTypography variant="body2" fontSize={13}>
                  {draftValue}
                </MDTypography>
              }
            />
            <MDButton
              size="small"
              color="warning"
              variant="outlined"
              iconOnly
              onClick={() => {
                try {
                  const key = `draft_${formRef}`;
                  const saved = localStorage.getItem(key);
                  if (!saved) return;

                  const parsed = JSON.parse(saved);

                  if (parsed?.values && fieldRef in parsed.values) {
                    delete parsed.values[fieldRef];
                  }

                  // persist updated draft
                  localStorage.setItem(key, JSON.stringify(parsed));

                  // update UI state
                  setHasSavedValue(false);
                  setDraftValue(null);
                } catch (e) {
                  console.error("Failed to clear draft field", e);
                }
              }}
            >
              <Icon>edit</Icon>
            </MDButton>
          </ListItem>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={draftValue}
          />
        </MDBox>
      ) : (
        <MDBox>
          <TextField
            inputRef={ref}
            margin="dense"
            label={displayName}
            type="text"
            fullWidth
            variant="outlined"
            multiline
            minRows={2}
            options={options}
          />
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={`${fieldRef}`}
            value={googleAddressObject}
          />
        </MDBox>
      )}
    </MDBox>
  );
}

// Typechecking props of the Transaction
GoogleAddressField.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GoogleAddressField.defaultProps = {
  options: null,
};

export default GoogleAddressField;
